import { Button, ButtonProps } from "antd";
import classNames from "classnames";
import styles from "./style.module.scss";
import { forwardRef, ReactNode } from "react";
import VLPopover from "../../VLPopover";
import { ButtonType } from "antd/es/button/buttonHelpers";

type VLButtonPropsBase = Omit<ButtonProps, "type"> & {
  tooltip?: ReactNode;
  text?: string;
};

export type VLPrimaryButtonProps = VLButtonPropsBase & {
  type: "primary";
  isGradient?: boolean;
};
export type VLNormalButtonProps = VLButtonPropsBase & {
  type: Exclude<ButtonType, "primary">;
};

export type VLButtonProps = VLNormalButtonProps | VLPrimaryButtonProps;

const VLButton = forwardRef<HTMLButtonElement, VLButtonProps>(
  ({ tooltip, className, size = "large", ...rest }, ref) => {
    const btnClassName = classNames(styles.vlButton, className, {
      [styles.gradient]: rest.type === "primary" && rest.isGradient,
    });
    return (
      <VLPopover content={tooltip}>
        <Button ref={ref} className={btnClassName} size={size} {...rest}>
          {rest.text || rest.children}
        </Button>
      </VLPopover>
    );
  },
);

export default VLButton;
